<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Add Food</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>
  <form nz-form [formGroup]="foodItemForm">
    <div mat-dialog-content>
      <div class="row">
        <div class="d-none d-md-block col-md-2">
          @for (section of foodSection; track section.name) {
            <div class="menu-box me-3 mb-3 cursor" (click)="scrollTo(section.name)"
              [ngClass]="{'tab-selected': currentSection === section.name}">
              <p class="mb-0 nav-label">{{ section.name }}</p>
            </div>
          }
        </div>
        <div class="col-sm-12 col-md-7">
          <div scrollSpy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)" class="scrollItems">
            <section id="Basic">
              <div class="section-header">
                <p class="section-title">Basic</p>
                <p class="section-subtitle">Food basic information</p>
              </div>
              <div class="row">
                <div class="col-4">
                  <nz-form-item>
                    <div class="w-100">
                      <nz-form-label nzRequired>Item Code</nz-form-label>
                      <nz-form-control nzErrorTip="Item code is required!">
                        <input nz-input formControlName="foodItemCode" type="text" placeholder="Enter Item Code">
                      </nz-form-control>
                    </div>
                  </nz-form-item>
                </div>
                <div class="col-8">
                  <nz-form-item>
                    <div class="w-100">
                      <nz-form-label nzRequired>Name</nz-form-label>
                      <nz-form-control nzErrorTip="Name is required!">
                        <input nz-input formControlName="name" type="text" placeholder="Enter name">
                      </nz-form-control>
                    </div>
                  </nz-form-item>
                </div>
              </div>
              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Description</nz-form-label>
                  <nz-form-control>
                    <div class="NgxEditor__Wrapper editor-wrapper">
                      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                      <ngx-editor
                        [editor]="editor"
                        formControlName="description"
                        outputFormat="html"
                        placeholder="Enter description">
                      </ngx-editor>
                    </div>
                  </nz-form-control>
                </div>
              </nz-form-item>
              <nz-form-item>
                <div class="w-100">
                  <nz-form-label nzRequired>Base Price</nz-form-label>
                  <nz-form-control nzErrorTip="Bese Price is required!">
                    <nz-input-number class="w-100" formControlName="basePrice"
                    nzPlaceHolder="Enter bese price"></nz-input-number>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <!-- Spicy Level & Satiety Level -->
              <div class="row">
                <div class="col-6">
                  <nz-form-item>
                    <div class="w-100">
                      <nz-form-label>Spicy Level</nz-form-label>
                      <nz-form-control>
                        <nz-select formControlName="spicyLevel" nzPlaceHolder="Select spicy level">
                          @for (opt of spicyLevelOptions; track opt.key) {
                            <nz-option [nzValue]="opt.key" [nzLabel]="opt.value"></nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                      @if (foodItemForm.get('spicyLevel')?.value !== null && foodItemForm.get('spicyLevel')?.value !== undefined) {
                        <span class="spicy-chip" [ngClass]="getSpicyLevelClass(foodItemForm.get('spicyLevel')?.value)">
                          {{ spicyLevelOptions[foodItemForm.get('spicyLevel')?.value]?.value }}
                        </span>
                      }
                    </div>
                  </nz-form-item>
                </div>
                <div class="col-6">
                  <nz-form-item>
                    <div class="w-100">
                      <nz-form-label>Satiety Level</nz-form-label>
                      <nz-form-control>
                        <nz-select formControlName="satietyLevel" nzPlaceHolder="Select satiety level" nzAllowClear>
                          @for (opt of satietyLevelOptions; track opt.key) {
                            <nz-option [nzValue]="opt.key" [nzLabel]="opt.value"></nz-option>
                          }
                        </nz-select>
                      </nz-form-control>
                    </div>
                  </nz-form-item>
                </div>
              </div>

              <!-- Daily Requirement & Feedback Percentage -->
              <div class="row">
                <div class="col-6">
                  <nz-form-item>
                    <div class="w-100">
                      <nz-form-label>Daily Requirement</nz-form-label>
                      <nz-form-control>
                        <nz-input-number class="w-100" formControlName="dailyRequirement"
                          [nzMin]="0" nzPlaceHolder="Enter daily requirement"></nz-input-number>
                      </nz-form-control>
                    </div>
                  </nz-form-item>
                </div>
                <div class="col-6">
                  <nz-form-item>
                    <div class="w-100">
                      <nz-form-label>Feedback %</nz-form-label>
                      <nz-form-control [nzErrorTip]="feedbackErrorTpl">
                        <nz-input-number class="w-100" formControlName="feedbackPercentage"
                          [nzMin]="0" [nzMax]="100" [nzStep]="1" [nzPrecision]="1"
                          nzPlaceHolder="0 - 100"></nz-input-number>
                        <ng-template #feedbackErrorTpl let-control>
                          @if (control.hasError('min')) {
                            Must be at least 0
                          } @else if (control.hasError('max')) {
                            Must be at most 100
                          }
                        </ng-template>
                      </nz-form-control>
                    </div>
                  </nz-form-item>
                </div>
              </div>

              <div formArrayName="foodQuantityTags">
                @for (foodQuantityTag of foodQuantityTags.controls; track foodQuantityTag; let i = $index) {
                  <div class="d-flex"
                    [formGroupName]="i">
                    <div class="col-4">
                      <nz-form-item>
                        <div class="w-100">
                          <nz-form-label nzRequired>Qty. Tagging</nz-form-label>
                          <nz-form-control nzErrorTip="Quantity Tag is required!">
                            <nz-select formControlName="foodQuantityTagId"
                              nzPlaceHolder="Select Quantity Tag">
                              @for (status of quantityTagKeyValue; track status) {
                                <nz-option [nzValue]="status.key"
                                [nzLabel]="status.value"></nz-option>
                              }
                            </nz-select>
                          </nz-form-control>
                        </div>
                      </nz-form-item>
                    </div>
                    <div class="col-3 ms-2">
                      <nz-form-item>
                        <div class="w-100">
                          <nz-form-label nzRequired>Cost</nz-form-label>
                          <nz-form-control nzErrorTip="Bese Price is required!">
                            <nz-input-number class="w-100" formControlName="additionalCost"
                            nzPlaceHolder="Enter price"></nz-input-number>
                          </nz-form-control>
                        </div>
                      </nz-form-item>
                    </div>
                    <div class="col-5 d-flex ms-2">
                      <nz-form-item>
                        <div class="w-100">
                          <nz-form-label nzRequired>Price</nz-form-label>
                          <nz-form-control nzErrorTip="Bese Price is required!">
                            <nz-input-number class="w-100" formControlName="additionalPrice"
                              nzPlaceHolder="Enter price"
                            (input)="onPrice($event,i,foodQuantityTag.get('foodQuantityTagId')?.value)"></nz-input-number>
                          </nz-form-control>
                        </div>
                      </nz-form-item>
                      <div class="my-auto ms-2">
                        <p class="mb-0 total-price">{{ foodQuantityTag.get('totalPrice')?.value | number }}</p>
                      </div>
                      <div class="ms-2 my-auto">
                        @if (i!=0) {
                          <a (click)="onDeleteFoodQuantityTag(i)">
                            <em class="las la-times text-danger mt-1 fs-5"></em>
                          </a>
                        }
                      </div>
                    </div>
                  </div>
                }
                <button (click)="onAddFoodQuantityTag()" class="btn-radius mt-0 mb-2" nz-button nzGhost nzType="primary"
                  nzSize="default">
                  <em class="las la-plus me-1"></em>
                  Quantity Tag
                </button>
              </div>


            </section>
            <section id="Menu">
              <div class="section-header mt-4">
                <p class="section-title">Menu</p>
                <p class="section-subtitle">Menu related components</p>
              </div>
              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Menu</nz-form-label>
                  <nz-form-control>
                    <nz-select nzMode="multiple" formControlName="menuIds" nzPlaceHolder="Select menu">
                      @for (menu of menuKeyValue; track menu) {
                        <nz-option [nzValue]="menu.key"
                        [nzLabel]="menu.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>
              <nz-form-item>
                <div class="w-100">
                  <nz-form-label nzRequired>Food Item Category</nz-form-label>
                  <nz-form-control nzErrorTip="Category is required!">
                    <nz-select formControlName="foodCategoryId" nzPlaceHolder="Select item type" nzShowSearch>
                      @for (status of itemCategoryKeyValue; track status) {
                        <nz-option [nzValue]="status.key"
                        [nzLabel]="status.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label nzRequired>Kitchen</nz-form-label>
                  <nz-form-control nzErrorTip="Kitchen is required!">
                    <nz-select formControlName="kitchenId" nzPlaceHolder="Select here" nzShowSearch>
                      @for (status of kitchenKeyValue; track status) {
                        <nz-option [nzValue]="status.key"
                        [nzLabel]="status.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>
            </section>
            <section id="Cost">
              <div class="section-header">
                <p class="section-title">Cost</p>
                <p class="section-subtitle">Food cost information</p>
              </div>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Material Cost</nz-form-label>
                  <nz-form-control>
                    <nz-input-number class="w-100" formControlName="materialCost"
                    nzPlaceHolder="Enter  material cost"></nz-input-number>
                  </nz-form-control>
                </div>
              </nz-form-item>
              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Overhead Cost</nz-form-label>
                  <nz-form-control>
                    <nz-input-number class="w-100" formControlName="overheadCost"
                    nzPlaceHolder="Enter overhead cost"></nz-input-number>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <!-- Computed Read-only Fields -->
              <div class="computed-costs-row">
                <div class="computed-cost-item">
                  <span class="computed-label">Total Cost</span>
                  <span class="computed-value">{{ totalCost | number:'1.2-2' }}</span>
                </div>
                <div class="computed-cost-item">
                  <span class="computed-label">Margin %</span>
                  <span class="computed-value" [ngClass]="marginPercentage >= 0 ? 'margin-positive' : 'margin-negative'">
                    {{ marginPercentage | number:'1.1-1' }}%
                  </span>
                </div>
              </div>
            </section>
            <section id="Tags">
              <div class="section-header">
                <p class="section-title">Tags</p>
                <p class="section-subtitle">Food tags</p>
              </div>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label nzRequired>Food Cook Type</nz-form-label>
                  <nz-form-control nzErrorTip="Food Cook Type is required!">
                    <nz-select formControlName="foodCookType" nzPlaceHolder="Select status" nzShowSearch>
                      @for (status of foodCookTypeKeyValue; track status) {
                        <nz-option [nzValue]="status.key"
                        [nzLabel]="status.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label nzRequired>Preparation Type</nz-form-label>
                  <nz-form-control nzErrorTip="Preparation Type is required!">
                    <nz-select formControlName="preparationType" nzPlaceHolder="Select Preparation Type" nzShowSearch>
                      @for (status of preparationTypeKeyValue; track status) {
                        <nz-option [nzValue]="status.key"
                        [nzLabel]="status.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Food Item Search Tag</nz-form-label>
                  <nz-form-control>
                    <nz-select nzMode="multiple" formControlName="foodSearchTagIds" nzPlaceHolder="Select search tag"
                      nzShowSearch>
                      @for (status of searchTagKeyValue; track status) {
                        <nz-option [nzValue]="status.key"
                        [nzLabel]="status.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Dietary Attributes</nz-form-label>
                  <nz-form-control>
                    <nz-select nzMode="multiple" formControlName="dietaryAttributes" nzPlaceHolder="Select dietary attributes">
                      @for (attr of dietaryAttributeOptions; track attr.key) {
                        <nz-option [nzValue]="attr.key" [nzLabel]="attr.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Ingredients</nz-form-label>
                  <nz-form-control>
                    <nz-select nzMode="multiple" formControlName="foodIngredientIds" nzPlaceHolder="Select ingredients" nzShowSearch>
                      @for (ing of ingredientKeyValue; track ing) {
                        <nz-option [nzValue]="ing.key" [nzLabel]="ing.value"></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </div>
              </nz-form-item>
            </section>
            <section id="Additional">
              <div class="section-header">
                <p class="section-title">Additional</p>
                <p class="section-subtitle">Food additional information</p>
              </div>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Cooking Method</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="cookingMethod" placeholder="Enter cooking method"/>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Basic Ingredients</nz-form-label>
                  <nz-form-control>
                    <textarea nz-input formControlName="basicIngredients"
                    placeholder="Enter basic ingredients"></textarea>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Allergens</nz-form-label>
                  <nz-form-control>
                    <textarea nz-input formControlName="allergens" placeholder="Enter allergens"></textarea>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Preparation Time</nz-form-label>
                  <nz-form-control>
                    <nz-input-number class="w-100" formControlName="preparationTime"
                    nzPlaceHolder="Enter preparation time"></nz-input-number>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <nz-form-item>
                <div class="w-100">
                  <nz-form-label>Origin</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="origin" placeholder="Enter origin"/>
                  </nz-form-control>
                </div>
              </nz-form-item>

              <!-- Macros (Collapsible) -->
              <div class="macros-panel">
                <div class="macros-header" (click)="macrosExpanded = !macrosExpanded">
                  <span class="macros-title">
                    <em class="las la-flask"></em> Nutritional Macros
                  </span>
                  <em class="las" [ngClass]="macrosExpanded ? 'la-angle-up' : 'la-angle-down'"></em>
                </div>
                @if (macrosExpanded) {
                  <div class="macros-body" formGroupName="macros">
                    <div class="row">
                      <div class="col-6">
                        <nz-form-item>
                          <div class="w-100">
                            <nz-form-label>Calories</nz-form-label>
                            <nz-form-control>
                              <nz-input-number class="w-100" formControlName="calories" [nzPrecision]="1" nzPlaceHolder="kcal"></nz-input-number>
                            </nz-form-control>
                          </div>
                        </nz-form-item>
                      </div>
                      <div class="col-6">
                        <nz-form-item>
                          <div class="w-100">
                            <nz-form-label>Protein</nz-form-label>
                            <nz-form-control>
                              <nz-input-number class="w-100" formControlName="protein" [nzPrecision]="1" nzPlaceHolder="g"></nz-input-number>
                            </nz-form-control>
                          </div>
                        </nz-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <nz-form-item>
                          <div class="w-100">
                            <nz-form-label>Carbohydrates</nz-form-label>
                            <nz-form-control>
                              <nz-input-number class="w-100" formControlName="carbohydrates" [nzPrecision]="1" nzPlaceHolder="g"></nz-input-number>
                            </nz-form-control>
                          </div>
                        </nz-form-item>
                      </div>
                      <div class="col-6">
                        <nz-form-item>
                          <div class="w-100">
                            <nz-form-label>Fat</nz-form-label>
                            <nz-form-control>
                              <nz-input-number class="w-100" formControlName="fat" [nzPrecision]="1" nzPlaceHolder="g"></nz-input-number>
                            </nz-form-control>
                          </div>
                        </nz-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        <nz-form-item>
                          <div class="w-100">
                            <nz-form-label>Fiber</nz-form-label>
                            <nz-form-control>
                              <nz-input-number class="w-100" formControlName="fiber" [nzPrecision]="1" nzPlaceHolder="g"></nz-input-number>
                            </nz-form-control>
                          </div>
                        </nz-form-item>
                      </div>
                      <div class="col-4">
                        <nz-form-item>
                          <div class="w-100">
                            <nz-form-label>Sugar</nz-form-label>
                            <nz-form-control>
                              <nz-input-number class="w-100" formControlName="sugar" [nzPrecision]="1" nzPlaceHolder="g"></nz-input-number>
                            </nz-form-control>
                          </div>
                        </nz-form-item>
                      </div>
                      <div class="col-4">
                        <nz-form-item>
                          <div class="w-100">
                            <nz-form-label>Sodium</nz-form-label>
                            <nz-form-control>
                              <nz-input-number class="w-100" formControlName="sodium" [nzPrecision]="1" nzPlaceHolder="mg"></nz-input-number>
                            </nz-form-control>
                          </div>
                        </nz-form-item>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </section>
          </div>
        </div>
        <div class="d-none d-md-block col-md-3">
          <div class="d-flex justify-content-end mt-1">
            <nz-switch [(ngModel)]="status" [ngModelOptions]="{standalone: true}"></nz-switch>
          </div>
          <div class="d-flex justify-content-center">
            <!--         <div class="food-card w-50" #card
            (mousemove)="onMouseMove($event, card)"
            (mouseleave)="onMouseLeave(card)">
            @if (data.btnTitle === 'Update' && data.foodItem.imageUrls && data.foodItem.imageUrls.length > 0) {
              <div class="food-image-container mb-2">
                <img [ngSrc]="data.foodItem.imageUrls[0]" width="300"
                  height="200" alt="Food Image" class="food-image"/>
                <div class="delete-icon" (click)="onDeleteImage(data.foodItem.imageUrls[0])">
                  <em class="las la-times mb-0" matTooltip="Delete"></em>
                </div>
              </div>
            }
            <div class="p-2">
              <div class="d-flex justify-content-between">
                <p class="mb-0 text-weight">{{ foodName }}</p>
                <p class="mb-0">{{ foodPrice | number }}</p>
              </div>
              <div class="food-description">
                <p class="text-muted">{{ description | truncate: 50 }}</p>
              </div>
              <div class="d-flex justify-content-between">
                <div class="item-code">
                  <p class="mb-0">{{ itemCode }}</p>
                </div>
                @if (isVegetarian) {
                  <img ngSrc="assets/images/veg-icon.png" width="25" height="25" alt="veg">
                } @else if (isNonVegetarian) {
                  <img ngSrc="assets/images/non-veg-icon.png" width="25" height="25" alt="non-veg">
                } @else {

                }
              </div>
            </div>
          </div>-->

          <div class="food-card w-50" #card
            (mousemove)="onMouseMove($event, card)"
            (mouseleave)="onMouseLeave(card)">


            <div class="p-2">
              <!-- Food Name -->
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="flex-grow-1">
                  <p class="mb-0 text-weight food-name">{{ foodName }}</p>
                </div>
              </div>

              <!-- Description -->
              <div class="food-description mb-2" [innerHTML]="foodItemForm.get('description')?.value"></div>

              <div class="d-flex justify-content-between gap-2">
                <!-- Item Code Badge -->
                <div class="item-code-badge">
                  <span class="badge badge-outline">{{ itemCode }}</span>
                </div>

                <!-- Veg/Non-veg Indicator-->
                <div class="veg-indicator-no-image">
                  @if (isVegetarian) {
                    <img ngSrc="assets/images/veg-icon.png" width="18" height="18" alt="veg">
                  } @else if (isNonVegetarian) {
                    <img ngSrc="assets/images/non-veg-icon.png" width="18" height="18" alt="non-veg">
                  }
                </div>
              </div>

              <!-- Price Ranges -->
              <div class="price-section">
                <p class="price-label mb-1">Price Options:</p>
                <div class="price-ranges">
                  @for (range of priceRange; track range.size) {
                    <div class="price-tag">
                      <span class="size-code">{{ range.size }}</span>
                      <span class="price-amount">{{ range.price | number }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="dialog-footer">
    <button class="dialog-btn dialog-btn-cancel" [mat-dialog-close]="true" nzType="primary" nzGhost nz-button>
      Cancel
    </button>
    <button nz-button nzType="primary" class="dialog-btn dialog-btn-submit" (click)="onSubmit()">
      Add
    </button>
  </div>
</form>



